import { render, staticRenderFns } from "./youtube-video-player.component.vue?vue&type=template&id=698bdd68&scoped=true&"
import script from "./youtube-video-player.component.vue?vue&type=script&lang=js&"
export * from "./youtube-video-player.component.vue?vue&type=script&lang=js&"
import style0 from "./youtube-video-player.component.vue?vue&type=style&index=0&id=698bdd68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698bdd68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VRow})
